import stage from '../components/stage'
import renderer from '../components/render'
import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollToPlugin } from "../ScrollToPlugin.js";
import { ScrollTrigger } from "../ScrollTrigger.js";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
import '../jquery.hoverIntent.js'



class Menu extends Component{

  constructor(element) {

    super(element)


    this.body = $('body')

    this.element = element

    this.ref =  {

    }

  }


  mount() {

      $('#hamburger').on('click', (e)=>{
          $('body').toggleClass('has-menu')
          $('body').removeClass('has-submenu')
          $('body').removeClass('has-submenu-about')
      })

      $('#closemenu').on('click', (e)=>{
          $('body').removeClass('has-submenu')
          $('body').removeClass('has-submenu-about')
      })

      $("#abs").on('click', (e)=>{
          e.preventDefault()
      })


      if(stage.w < 768){
        $('#olm').on('click', (e)=>{
            e.preventDefault()
            $('body').toggleClass('has-submenu')
        })
      }

      if(stage.w < 768){
        $('#abs').on('click', (e)=>{
            e.preventDefault()
            $('body').toggleClass('has-submenu-about')
        })
      }
      
      if ($('.cover__content .clc-logo').length > 0){

      ScrollTrigger.create({
        trigger: '.cover__content .clc-logo',
        start: "top top",
        //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
        onEnter: (self) => {
          //console.log(el.dataset.color, "active:" + self.isActive)
          $('.menu--home .logo').addClass(`in-view`)
        },
        onLeaveBack: (self) => {
          //console.log(el.dataset.color, "active:" + self.isActive)
          $('.menu--home .logo').removeClass(`in-view`)
        }
      });

}

      _each($('[data-color]'), (el)=>{
        ScrollTrigger.create({
          trigger: el,
          start: "top 1%",
          //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
          onToggle: (self) => {
            //console.log(el.dataset.color, "active:" + self.isActive)
            $('body').toggleClass(`menu-color-${el.dataset.color}`)
          }
          });
      })

      _each($('[data-body]'), (el)=>{
        ScrollTrigger.create({
          trigger: el,
          start: "top 1%",
          //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
          onToggle: (self) => {
            //console.log(el.dataset.color, "active:" + self.isActive)
            $('body').toggleClass(`body-color-${el.dataset.color}`)
          }
          });
      })

      _each($('.abox'), (el)=>{
        ScrollTrigger.create({
          trigger: el,
          start: "top bottom+=5%",
          //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
          onEnter: (self) => {
            //console.log(el.dataset.color, "active:" + self.isActive)
            $(el).addClass('in-view')
          }
          });
      })

      this.wheel = $("#wheel")
      this.wheel.length > 0 && gsap.fromTo(this.wheel,

        {
          rotation: 0,
          ease: "none"

        },

        {
        rotation: 1440,
        //yPercent: -50,
        ease: "none",
        scrollTrigger: {
          trigger: ".cover-olm",
          start: "top 50%",
          endTrigger: ".footer",
          scrub: 1
        },
      });


      $("#olm").hoverIntent( this.makeTall.bind(this), this.makeShort.bind(this) );
      $("#subnav").on('mouseleave', (e)=>{
        this.body.removeClass('has-submenu')
      })


      $("#abs").hoverIntent( this.makeTallf.bind(this), this.makeShortf.bind(this) );
      $("#subnav-about").on('mouseleave', (e)=>{
        this.body.removeClass('has-submenu-about')
      })

      $("#adm").hoverIntent( this.makeTalle.bind(this), this.makeShort.bind(this) );
      $("#subnav-fees").on('mouseleave', (e)=>{
        this.body.removeClass('has-submenu-fees')
      })


      this.resizeQue = this.resize.bind(this)
      stage.on("stage:resize", this.resizeQue);
      this.renderQue = this.render.bind(this)
      stage.on("stage:scroll", this.renderQue);
      this.resize(stage);



  }

  makeTall(){
    this.body.addClass('has-submenu')
  }

  makeShort(){
    //this.body.removeClass('has-submenu')
  }

  makeTallf(){
    this.body.addClass('has-submenu-about')
  }

  makeTalle(){
    this.body.addClass('has-submenu-fees')
  }

  makeShortf(){
    //this.body.removeClass('has-submenu')
  }

  makesTall(){
    //this.body.addClass('has-submenu')
  }

  makesShort(){

  }



  resize(e){
    this.render(e)
  }

  render(e){

  }


  renderQueCall(){



  }

  unmount() {


    stage.removeListener("stage:resize", this.resizeQue);
    stage.removeListener("stage:scroll", this.renderQue);
    this.el.removeClass('active')


  }


}

module.exports = Menu
